export default __webpack_public_path__ + "static/media/icon-burger.0f2c57ae.svg";